// Single source of truth for the merchant details shown on /privacy, /termsofuse and /support.
// These must match the details registered with the acquiring bank (Raiffeisen Bank Albania — RaiAccept).
export const COMPANY = {
  legalName: "Eagle Inc Sh.P.K.",
  tradeNames: "Eagle Eyes Group; Eagle Commerce Group; Eagle Eyes IT Management; Eagle Eyes Real Estate; SocialDeal",
  // NUIS / NIPT (tax & registration number, QKB). Left empty = not rendered.
  nuis: "M62130024O",
  address: "Rruga Ahmet Duhaxhiu 14, 1003 Tirana, Albania",
  country: "Albania",
  servicePoint: "Eagle Inc - Support",
  supportEmail: "support@eagle-inc.net",
  supportPhone: "+355 69 680 3306",
  supportPhoneHref: "+355696803306",
  website: "www.eagle-inc.net",
  supportUrl: "https://www.eagle-inc.net/support",
};
